import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FinancialInstitutionTypes } from '@models/lender';
import { MatterMortgage } from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';
import {
	DropdownOption,
	DropdownOptions,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

@Component({
	selector: 'app-charge-type-dropdown',
	templateUrl: './charge-type-dropdown.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [TitleCasePipe],
	standalone: false,
})
export class ChargeTypeDropdownComponent {
	public _mortgage: MatterMortgage;
	public chargeTypesDropdownOptions: DropdownOptions<string>;
	public selectedChargeTypeText: string;
	public isDisabled = false;

	@Input() forceErrorState = false;

	@Input() set mortgage(mortgage: MatterMortgage) {
		this._mortgage = mortgage;

		const validFinancialInstitutionTypes = [
			FinancialInstitutionTypes.GENERAL_FINANCIAL_INSTITUTION,
			FinancialInstitutionTypes.CREDIT_UNION,
			FinancialInstitutionTypes.TRUST_COMPANY,
		];

		const lender = Object.values(mortgage?.lenders ?? {})?.find((lender) =>
			validFinancialInstitutionTypes.includes(lender.type),
		);

		const chargeTypesList = Object.keys(lender?.chargeTypes ?? {});
		this.chargeTypesDropdownOptions = chargeTypesList.map((chargeType) => ({
			name: this.titleCasePipe.transform(chargeType),
			value: chargeType,
		}));
		this.selectedChargeTypeText = this.titleCasePipe.transform(
			mortgage.chargeType ?? '',
		);

		if (this.chargeTypesDropdownOptions.length === 1) {
			this.isDisabled = true;
			if (!mortgage.chargeType) {
				this.mortgageDispatch.SetMortgageChargeType(
					this._mortgage.id,
					this.chargeTypesDropdownOptions[0].value,
				);
			}
		}
	}

	constructor(
		private mortgageDispatch: MatterMortgageDispatch,
		private titleCasePipe: TitleCasePipe,
	) {}

	public onSelectChargeType(
		chargeType: DropdownResult<DropdownOption<string>>,
	): void {
		this.mortgageDispatch.SetMortgageChargeType(
			this._mortgage.id,
			chargeType.result.value,
		);
	}
}
